import './MinimalDropdown.scss'

import React from 'react'

import { SelectDropdown } from '../SelectDropdown'
import { MinimalButton } from '../MinimalButton'

/**
 * Minimalistic dropdown select element.
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} [props.className]
 * @param {import("../DropdownList").DropdownOptionValues[]} props.options
 * @param {number|string} props.value
 * @param {string} [props.name]
 * @param {(value: number|string, name?: string) => void} props.onChange
 */
const MinimalDropdown = props => {
    const dropdownProps = {
        ...props,
        className: 'minimal-dropdown' + (props.className ? ' ' + props.className : ''),
        renderTrigger: props => <MinimalButton {...props} align iconAfter="i-caret-down" />,
    }

    return <SelectDropdown {...dropdownProps} withPlaceholder />
}

export default MinimalDropdown
